import { saveTranslation } from "src/common/api/apiTranslation";
import { EdObject, edit2obj } from "../../Obj2Tab/EdObject";
import { zLightObject } from "../../Obj2Tab/Obj2Nodes";
import { saveObjReqAttributes } from "../../Obj2Tab/RequiredAttributes/apiRequiredAttributes";
import {
  saveObjectRolesMap,
  smartDeleteObjectStates,
} from "../../Obj2Tab/roles/rolesApi";
import { createLightObject, saveLightObject } from "../../objectsApi";
import { patchDelayedNotify, patchNotifyTemplates } from "../api/notifications";
import { ObjectNode, objectNodeId, unsavedId } from "../model/node";
import { objectFields } from "./object";
import { KindContext, SaveResult } from "./types";

/**
 * Сохранение объекта.
 *
 * Вынесено из обработчика: одних только сопутствующих сохранений здесь шесть
 * (переводы, роли, состояния, шаблоны уведомлений, отложенные уведомления,
 * обязательные атрибуты), и вместе с остальным поведением варианта файл вышел
 * бы за все разумные размеры.
 */
export const saveObjectNode = async (
  node: ObjectNode,
  values: unknown,
  ctx: KindContext,
): Promise<SaveResult> => {
  const current = objectFields(node, ctx);
  const {
    lightObject,
    rolesMap,
    states,
    translation,
    templatesMap,
    delayedNotifyMap,
    requiredAttrsMap,
    disableVersionAudit,
  } = edit2obj(values as EdObject);

  const fields = zLightObject.partial().parse(lightObject);
  const source = { ...current, ...fields, disableVersionAudit };
  const { id, ...withoutId } = source;

  // Ответ на создание берём только ради нового идентификатора: списка прав в
  // нём нет, и как данные объекта он не годится - объект перечитывается
  const created =
    id === unsavedId ? await createLightObject(withoutId) : undefined;
  const saved = created
    ? zLightObject.parse(created)
    : await saveLightObject(id, source);
  const objectId = saved.id;

  await Promise.all([
    translation
      ? saveTranslation(current.name, {
          value: fields.name ?? "",
          translations: translation,
        })
      : undefined,
    rolesMap ? saveObjectRolesMap(objectId, rolesMap) : undefined,
    // Удалённые на форме состояния нужно убрать отдельными запросами
    states ? smartDeleteObjectStates(objectId, states) : undefined,
    templatesMap ? patchNotifyTemplates(objectId, templatesMap) : undefined,
    delayedNotifyMap
      ? patchDelayedNotify(objectId, delayedNotifyMap)
      : undefined,
    requiredAttrsMap
      ? saveObjReqAttributes(objectId, requiredAttrsMap)
      : undefined,
  ]);

  return { objectId, selectId: objectNodeId(objectId) };
};
